import TpClientInvoiceLineItem from '../../../../Domain/TpClientInvoiceLineItem';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import TpClientInvoiceLineItemService from '../../../../Services/TpClientInvoiceLineItemService';
import React from 'react';

export default class TpClientInvoiceLineItemDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  lineItemId = this.urlParams.get('id');

  static getMenuText() {
    const id = new URLSearchParams(window.location.search).get('id');
    return `Third-Party Client Invoice Line Item ${id ? '- ' + id : 'Details'}`;
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.lineItemId}
        entityName='Line Item Details'
        type={TpClientInvoiceLineItem}
        serviceGetByIdFunction={TpClientInvoiceLineItemService.GetById}
      />
    );
  }
}
